import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\wamp64\\www\\cyberstone\\components\\Home\\Main.tsx");
